import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FormUtils, assert } from 'ats-ui-lib';
import { ExtraInformationJobApplication } from '../../models/job-opportunity-application.model';
import { ResumeApplicantService } from '@pages/applicant/pages/register-applicant/services/resume-applicant.service';

@Injectable({
  providedIn: 'root',
})
export class FormExtraApplicationOrchestrationService {
  private extraInformationFormGroup?: UntypedFormGroup;

  constructor(private resumeApplicantService: ResumeApplicantService) {}

  public buildComplementaryForm(form: UntypedFormGroup): UntypedFormGroup {
    assert(form);
    this.extraInformationFormGroup = FormUtils.getFormControl(form, 'fifthStep.extraInformation');

    return this.extraInformationFormGroup;
  }

  public getAnswers(jobOpportunityId: string): ExtraInformationJobApplication {
    return (
      this.resumeApplicantService.getExtraInformationBy(jobOpportunityId) ??
      this.extraInformationFormGroup?.value
    );
  }
}
